import { render, staticRenderFns } from "./OrderRow.vue?vue&type=template&id=02289f4a&scoped=true"
import script from "./OrderRow.vue?vue&type=script&lang=ts"
export * from "./OrderRow.vue?vue&type=script&lang=ts"
import style0 from "./OrderRow.vue?vue&type=style&index=0&id=02289f4a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02289f4a",
  null
  
)

export default component.exports